import xss from 'xss';

export const convertToSanitzedString = (text: string) => {
  const sanitized = xss(text, {});

  return sanitized;
};
